import { useProcedureStageComponentStore } from '@/stores/procedureStageComponentStore';
import { PROCEDURE_TYPE } from '@/lib/procedure';
import ProcedureStages from '@/components/procedure/ProcedureStages.vue';

function registerRoutes() {
    const stageStore = useProcedureStageComponentStore();
    stageStore.register(PROCEDURE_TYPE.ProposalsRequest, ProcedureStages);
}

export default {
    registerRoutes,
};
